/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import HTMLEditor from "../HTMLEditor";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import FormLabel from "../FormLabel";

class RequestFormEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.submitRef = React.createRef();
        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
        this.onContentChange = this.onContentChange.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<>
            <button type="button" className="btn btn-success" onClick={() => this.submitRef.current?.click()}><Icon icon="faSave" /> <span className="d-none d-md-inline"><L>Save</L></span></button>
            <button type="button" className="btn btn-secondary" onClick={this.goBack}><Icon icon="faCancel" /> <span className="d-none d-md-inline"><L>Cancel</L></span></button>
        </>);
        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        if (this.props.params.id) {
            qreq.get('/api/form/type/' + this.props.params.id, j => {
                if (j.item)
                    this.setState({ info: j.item });
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
    }

    onContentChange(v) {

        var fields = [];

        var matches = v.matchAll(/<input([^>]+)>/g);
        matches = Array.from(matches);
        matches.forEach(m => {
            var info = {};
            var fieldMatches = m[1].matchAll(/([^=]+)="([^"]+)"/g);
            fieldMatches = Array.from(fieldMatches);
            fieldMatches.forEach(i => {
                i[1] = i[1].trim();
                i[2] = i[2].trim();
                if (i[1] === "data-type")
                    info.fieldType = i[2];
                if (i[1] === "name")
                    info.fieldIdent = i[2];
                if (i[1] === "placeholder")
                    info.fieldName = i[2];
                if (i[1] === "required")
                    info.required = true;
            });
            fields.push(info);
        });


        this.setState({ info: { ...this.state.info, content: v, formFields: fields } });
    }

    submit(e) {
        e?.preventDefault();
        qreq.post('/api/form/type/save', { ...this.state.info }, j => {
            if (j.errorCode === 0) {
                this.success('Form saved successfully.', 'success');
                if (this.state.info.id !== j.item.id)
                    this.props.navigate('/form/type/edit/' + j.item.id);
                this.setState({ info: j.item });
            } else {
                this.alert(j.errorMessage);
            }
        }, this.unkownErrorCallback);
    }

    render() {
        return <div className="container-fluid">

            <h1><L>Request Form Edit</L></h1>
            <form onSubmit={this.submit}>
                <Card title="Template">
                    <FormInput model={this.state.info} name="name" label="Name" type="text" required />
                    <HTMLEditor linkValue value={this.state.info.content} onChange={v => this.onContentChange(v)} style={{ height: '80vh' }} />
                </Card>
                <Card title="Fields">
                    {this.state.info.formFields?.map((i, idx) => <div key={idx} className="row align-items-end mb-3">
                        <div className="col-md-4">
                            <FormLabel model={i.fieldName} name="fieldName" label="Field" type="text" required />
                        </div>
                        <div className="col-md-4">
                            <FormLabel model={i.fieldType} name="fieldType" label="Type" type="select" required options={[
                                { id: 'text', name: 'Custom Text' },
                                { id: 'Patient', name: 'Patient Information' },
                                { id: 'Signature', name: 'Signature' }
                            ]} />
                        </div>
                    </div>)}
                </Card>
                <input type="submit" className="d-none" ref={this.submitRef} />
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(RequestFormEdit);